import React from 'react'
import { Button } from 'react-bootstrap'
import { Brain, Check } from 'lucide-react'

interface ActionBarProps {
  selectedModelName?: string
  hasSelection: boolean
  onClearSelection: () => void
  onCancel: () => void
  onConfirm: () => void
  confirmDisabled?: boolean
}

const ActionBar: React.FC<ActionBarProps> = ({
  selectedModelName,
  hasSelection,
  onClearSelection,
  onCancel,
  onConfirm,
  confirmDisabled,
}) => {
  return (
    <div className="bg-dark border-top border-secondary d-flex justify-content-between align-items-center shadow-lg position-sticky bottom-0 z-3 px-4 py-3">
      {hasSelection ? (
        <div
          className="d-flex align-items-center gap-3 rounded-3 border border-success-subtle px-3 py-2"
          style={{
            background: 'linear-gradient(135deg, rgba(86,171,47,0.125), rgba(168,230,207,0.125))',
            boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
          }}
        >
          <div
            className="fw-semibold d-flex align-items-center gap-2 flex-grow-1 text-truncate"
            style={{ fontSize: '1.1rem' }}
          >
            <Check size={18} />
            <strong className="text-truncate" style={{ maxWidth: 300 }}>
              {selectedModelName || 'Model'}
            </strong>{' '}
            selected
          </div>
          <Button
            onClick={onClearSelection}
            className="flex-shrink-0"
            style={{ background: '#56ab2f30', color: '#a8e6cf', border: '1px solid #56ab2f60' }}
          >
            Clear Selection
          </Button>
        </div>
      ) : (
        <div
          className="rounded-3 border border-primary-subtle px-3 py-2 d-flex align-items-center gap-2"
          style={{
            background: 'linear-gradient(135deg, rgba(102,126,234,0.125), rgba(118,74,162,0.125))',
            color: '#b3c3ff',
          }}
        >
          <Brain size={16} className="text-primary" />
          <span>No model selected - choose a model to continue</span>
        </div>
      )}

      <div className="d-flex gap-2">
        <Button variant="outline-secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={!!confirmDisabled}>
          Select Model
        </Button>
      </div>
    </div>
  )
}

export default ActionBar
